import type { ReactElement } from 'react';
import { useMatches } from 'react-router';
import type { PageLayoutElements } from './layout/PageLayout';
import type { LayoutSize } from '../post/utils/useLayoutSize';

export interface RouteHandle {
  routeName?: string;
  pageLayout?: PageLayoutElements;
  ensureRole?: 'user' | 'admin' | 'anonymous' | 'userOrAnonymous';
  /**
   * If specified, the route will only be accessible if the layout size is at least this big.
   * If the layout size is smaller, and a fallback is provided, the fallback will be rendered instead.
   * If no fallback is provided, the user will be redirected to the home page
   */
  ensureMinSize?: LayoutSize | { minSize: LayoutSize; fallback: ReactElement };
}

interface Match {
  handle: RouteHandle;
}

function useRouteHandle() {
  const matches = useMatches();
  const {
    routeName = '',
    pageLayout = {},
    ensureRole,
    ensureMinSize,
  } = matches.reduce(
    (acc: Match['handle'], match) => ({
      ...acc,
      ...(match as Match).handle,
    }),
    {},
  );

  return { routeName, pageLayout, ensureRole, ensureMinSize };
}

export default useRouteHandle;
